import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/home";
import Header from "./components/header";
import About from "./pages/about";
import Contact from "./pages/contact";
import Footer from "./components/footer";
import ServiceGold from "./pages/service";
import ServiceAssociate from "./pages/associate";
import Admin from "./admin/admin";
import Login from "./admin/login";
import { useCookies } from "react-cookie";
import Console from "./admin/console";
import NotFound from "./pages/404";
import Terms from "./pages/terms";
import Privacy from "./pages/privacy";

function App(){
  const location = useLocation()
  const pathName = location.pathname.split('/')[1]

  const [cookies] = useCookies(['auth'])
  
  return(
    <>
      {pathName!="admin" &&<Header/>}
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/service" element={<ServiceGold/>}/>
        <Route path="/associate" element={<ServiceAssociate/>}/>
        <Route path="/terms" element={<Terms/>}/>
        <Route path="/policy" element={<Privacy/>}/>
        
        <Route path="*" element={<NotFound/>}/>

        <Route path="/admin" element={<Admin/>}>
          <Route path="/admin/login" element={cookies.auth?<Navigate to={'/admin/console'}/>:<Login/>}/>
          <Route path="/admin/console" element={cookies.auth?<Console/>:<Navigate to={'/admin/login'}/>}/>
        </Route>

      </Routes>
      {pathName!="admin" &&<Footer/>}
    </>
  )
}

export default App;